var RequestConstants = /** @class */ (function () {
    function RequestConstants() {
    }
    RequestConstants.ConfigurationTypes = {
        RequestHeaders: "request_headers"
    };
    RequestConstants.UrlParameters = {
        RelativePath: "relative_path"
    };
    RequestConstants.ApiCallTemplate = "/api/v1/<%= ".concat(RequestConstants.UrlParameters.RelativePath, " %>");
    RequestConstants.AbsoluteApiCallTemplate = "<%= ".concat(RequestConstants.UrlParameters.RelativePath, " %>");
    return RequestConstants;
}());
export { RequestConstants };
